export default __webpack_public_path__ + "static/media/checked-icon.9e645c4a.svg";